enum AssetType {
  FIXED_INCOME = 70,
  STOCKS = 83,
  OTHERS = 79
}

export enum AssetName {
  FIXED_INCOME = 'Renda Fixa',
  VARIABLE_INCOME = 'Renda Variável',
  STOCKS = 'Ações',
  OTHERS = 'Outros',
  MULTIMARKET = 'Multimercado'
}

export function getAssetNameByCode(id: number): string {
  let assetName: string;

  switch (id) {
    case AssetType.FIXED_INCOME:
      assetName = AssetName.FIXED_INCOME;
      break;
    case AssetType.STOCKS:
      assetName = AssetName.STOCKS;
      break;
    case AssetType.OTHERS:
    default:
      assetName = AssetName.OTHERS;
      break;
  }

  return assetName;
}

export function getAssetColor(assetType: string, isText = false) {
  let color;
  assetType = String(assetType).toLowerCase();

  switch (assetType) {
    case 'ações':
    case 'renda variável':
    case '83':
      color = '4';
      break;
    case 'outros':
    case '79':
      color = '1';
      break;
    case 'multimercado':
      color = '2';
      break;
    case 'renda fixa':
    case '70':
      color = '8';
      break;
    default:
      return `wrn-${isText ? 'color' : 'bg'}-gray-3`;
  }

  // if the color needed is not for text (background!), returns with 'wrn-bg-' prefix
  return `wrn-${!isText ? 'bg-' : ''}color-${color}`;
}
